import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { Link } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

// Component styles
import styles from './styles';

// Material components
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import UpdateIcon from '@material-ui/icons/Update';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import InfoIcon from '@material-ui/icons/Info';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ClearIcon from '@material-ui/icons/Clear';


import moment from 'moment'
import 'moment/locale/es'
import { tr } from 'date-fns/locale';
import { getQueryParams } from '../../../../utils/fns/get-query-params';
import compose from 'recompose/compose';
import { useTranslation, withTranslation } from 'react-i18next';
moment.locale('es')
const date = ((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))

class SummaryObjectives extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            path: null,
            listObjectives: {},
            nameStatus: 'Objetivos ',
            selectedOption: null,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptions: this._chartOptionsBase,
            chartOptionsStackedBarBase: this._chartOptionsStackedBarBase,
            chartOptionsStackedBar: this._chartOptionsStackedBarBase,
            settingsEl: null,
            isInfo: null,
            date: (moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")
        }

    }
    _chartOptionsBase = {
        chart: {
            backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                stops: [
                    [0, '#2a2a2b'],
                    [1, '#3e3e40']
                ]
            },
            type: 'pie',
            zoomType: 'x',
            ignoreHiddenSeries: false,
            marginRight: 30,
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#41739D',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            }
        },
        title: {
            text: null,

        },
        subtitle: {
            align: 'center',
            verticalAlign: 'middle',
            style: {
                color: '#434348',
                fontWeight: 'bold',
                //fontSize: '1.5em'

            },
            y: 10,
            x: -10
        },
        plotOptions: {
            pie: {
                animation: {
                    duration: 750,
                    easing: 'easeOutQuad'
                },
                shadow: false,
                center: ['50%', '50%'],
                cursor: 'pointer',
                dataLabels: {
                    enabled: false
                },
            },
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: true
        },
        tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        /*series: [
            {
                size: '100%',
                innerSize: '50%',
                name: ' ',
            }
        ]*/

    }

    _chartOptionsStackedBarBase = {
        chart: {
            backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                stops: [
                    [0, '#2a2a2b'],
                    [1, '#3e3e40']
                ]
            },
            type: 'bar',
            zoomType: 'x',
            ignoreHiddenSeries: false,
            marginRight: 30,
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#41739D',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            },
        },
        title: {
            text: '',

        },
        plotOptions: {
            series: {
                stacking: 'normal'
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },


    }

    setHoverData = (e) => {
        const { params } = this.state
        let name = e.point.dataName
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + name,
            listObjectives: params[name]
        });
    }
    setHoverDataBar = (e) => {

        const { params } = this.state
        const { category, series } = e.point
        let nameCat = category
        let nameStatus = series.name
        var filterParams = params[nameStatus].filter(param => param['grupo_servicio_unificado'] == nameCat)
        this.setState({
            isOpen: true,
            nameStatus: 'Objetivos ' + nameCat,
            listObjectives: filterParams
        });
    }
    onOpenModal = () => {
        this.setState({ isOpen: true });
    };

    onCloseModal = () => {
        this.setState({ isOpen: false });
    };

    componentDidMount() {
        this.processData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.loadObjectiveData) {
            this.processData()
        }
    }


    processData = () => {
        const { t } = this.props;
        return new Promise(resolve => {
            setTimeout(() => {
                const { params } = this.props;
                let arrayChartData = {}
                let arrayChartDataStackedBar = []
                let categoriesStackedBar = []
                let dictChartData = []
                const colors = ['#41B900', '#C2272D', '#A9A9A9', '#FFC600'];
                let numTotal = params.Uptime.length + params.Downtime.length + params.NoMonitoring.length + params.Partial.length
                params.ServicesUnified.forEach((item) => {
                    categoriesStackedBar.push(item)
                });
                Object.keys(params).map((key) => {
                    if (key !== 'Services' && key !== 'ServicesUnified') {
                        let dictData = {}
                        let dictDataStackedBar = {}
                        let color = ''
                        let name = ''
                        if (key == 'Uptime') {
                            color = colors[0]
                            name = t('summary-objectives.chart.uptime')
                        } else if (key == 'Downtime') {
                            color = colors[1]
                            name = t('summary-objectives.chart.downtime')
                        } else if (key == 'NoMonitoring') {
                            color = colors[2]
                            name = t('summary-objectives.chart.no-monitoring')
                        } else if (key == 'Partial') {
                            color = colors[3]
                            name = t('summary-objectives.chart.partial')
                        }
                        dictDataStackedBar['name'] = key
                        dictDataStackedBar['color'] = color
                        dictData['name'] = name
                        dictData['color'] = color
                        dictData['y'] = (params[key].length / numTotal) * 100
                        dictData['selected'] = false
                        dictData['x'] = params[key]
                        dictData['dataName'] = key
                        dictChartData.push(dictData)
                        var groupedServices = groupBy(params[key], 'grupo_servicio_unificado');
                        let categoriesDataStackedBar = []

                        categoriesStackedBar.forEach((catItem) => {
                            var isSame = false
                            Object.keys(groupedServices).map((key) => {
                                if (catItem == key) {
                                    categoriesDataStackedBar.push(groupedServices[key].length)
                                    isSame = true
                                }
                            })
                            if (!isSame) {
                                categoriesDataStackedBar.push(0)
                            }
                        })
                        dictDataStackedBar['data'] = categoriesDataStackedBar
                        arrayChartDataStackedBar.push(dictDataStackedBar)
                    }

                })
                arrayChartData['data'] = dictChartData
                this.setState({
                    chartOptions: {
                        subtitle: {
                            text: '<center><font size="+3">' + numTotal + '</font></center><br>' + t('summary-objectives.monitors'),
                            useHTML: 'true',
                            style: {
                                color: 'white'
                            }
                        },
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                point: {
                                    events: {
                                        click: this.setHoverData.bind(this)
                                    }
                                },
                                size: '100%',
                                innerSize: '50%',
                                name: ' ',
                            }
                        },
                        series:
                            arrayChartData
                    },
                    chartOptionsStackedBar: {
                        xAxis: {
                            categories: categoriesStackedBar,
                            labels: {
                                style: {
                                    color: 'white'
                                }
                            }
                        },
                        yAxis: {
                            labels: {
                                style: {
                                    color: 'white'
                                }
                            }
                        },
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                point: {
                                    events: {
                                        click: this.setHoverDataBar.bind(this)
                                    }
                                }
                            }
                        },
                        series: arrayChartDataStackedBar
                    },
                    loadObjectiveData: true,
                    isLoading: false,
                    params: params,
                    date: (moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")
                });
                resolve(true);

            }, 2000);
        });

    }

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleChange = (selectedOption) => {
        const { passProps } = this.props
        this.setState({ selectedOption });
        //passProps.onClick(passProps, selectedOption.value)
    };

    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleRefresh = () => {
        this.setState({
            loadObjectiveData: false,
            isLoading: true,
            settingsEl: null
        });
    };

    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };



    render() {
        const { dataError, chartOptions, chartOptionsStackedBar, isLoading, isOpen, listObjectives, selectedOption, nameStatus,
            date, settingsEl, isInfo } = this.state;
        const { classes, className, handleClose, isForModal, t, ...rest } = this.props;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const rootClassName = classNames(classes.root, className);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        let isForModalEl = false
        if (isForModal == true) {
            isForModalEl = true
        }
        const divStyle = {
            top: '12%', left: '20%', width: '60%'
        };

        return (
            <PortletContent className={rootClassName}>
                <PortletHeader className={classes.header}>
                    <PortletLabel
                        variant="h6"
                        title={t("summary-objectives.title")}
                        style={{ color: 'white' }}
                    />
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <IconButton
                            onClick={this.handleShowSettings}
                            styles={{ float: 'right' }}
                        >
                            <SettingsOutlinedIcon style={{ color: 'white' }} />
                        </IconButton>
                        {isForModalEl ?
                            <IconButton
                                onClick={handleClose}
                            >
                                <ClearIcon style={{ color: 'white' }} />
                            </IconButton>
                            : null}
                    </div>

                    <Popover
                        anchorEl={settingsEl}
                        onClose={this.handleCloseSettings}
                        open={showSettingsEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <IconButton style={{ display: 'flex', justifyContent: 'space-between' }}
                            onClick={this.handleRefresh}
                        >
                            <div>
                                <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{ fontSize: '15px', float: 'right', paddingLeft: '5px', color: '#66788A' }}>{t('text.update')}</Typography>
                            </div>
                        </IconButton>
                        <IconButton
                            onClick={this.handleShowIsInfo}
                            onClose={this.handleCloseIsInfo}
                        >
                            <div>
                                <InfoIcon color="infoIcon" />
                                <Typography variant="h4"
                                    style={{ fontSize: '15px', float: 'right', paddingLeft: '5px', color: '#66788A' }}
                                >{t('summary-objectives.label.information')}
                                </Typography>
                            </div>
                        </IconButton>
                        <Popover
                            //anchorEl={settingsEl}
                            open={showIsInfo}
                            onClose={this.handleCloseIsInfo}
                            style={divStyle}
                        >
                            <PortletContent>
                                <Typography align="center" variant="h4" style={{ fontSize: '13px', float: 'center', color: '#66788A' }}>
                                    {t('summary-objectives.chart.description')}
                                </Typography>
                            </PortletContent>
                        </Popover>
                    </Popover>
                </PortletHeader>
                <PortletContent className={classes.content}>

                    <FormattedChart chartOptions={chartOptions} chartOptionsStackedBar={chartOptionsStackedBar} style={style} styleHidden={styleHidden} classes={classes} date={date} />

                </PortletContent>
                <Popover open={isOpen} onClose={this.onCloseModal}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center'
                    }}>
                    <PortletLabel
                        variant="h6"
                        title="Monitoreos"
                    />
                    <Divider />
                    <PerfectScrollbar>
                        <List>
                            {listObjectives &&
                                <>
                                    {Object.keys(listObjectives).map(key => (
                                        <Link to={{
                                            pathname: `/online/${listObjectives[key].objetivo_id}/${listObjectives[key].nombre}/${listObjectives[key].nombre_servicio_unificado}`,
                                            search: getQueryParams(),
                                            state: {
                                                fromObjective: listObjectives[key]
                                            }
                                        }} onClick={this.onCloseModal}>
                                            <ListItem
                                                className={classes.listItem}
                                                component="div"
                                            >
                                                <ListItemIcon
                                                    className={classes.listItemIcon}
                                                />
                                                <Button id={listObjectives[key].nombre_servicio}>{listObjectives[key].nombre}

                                                </Button>

                                            </ListItem>
                                            <Divider />
                                        </Link>
                                    ))}
                                </>
                            }
                        </List>
                    </PerfectScrollbar>
                </Popover>
            </PortletContent>
        )
    }
}

function FormattedChart(props) {
    const { t } = useTranslation()
    return (
        <div>
            <div style={props.styleHidden}>

                <PortletContent>
                    <PerfectScrollbar>

                        <Typography
                            variant="h5"
                            style={{ color: 'white' }}
                        >
                            <CircularProgress
                                variant="indeterminate"

                                size={24}
                                thickness={4}

                            />
                            <br />
                            {t('text.loading')}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>
            <div style={props.style}>
                <Grid
                    container
                    spacing={10}
                >
                    {/* OBJETIVOS ACTICOS */}
                    <Grid
                        item
                        sm={6}
                        xl={6}
                        xs={12}
                    >
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={props.chartOptions} />
                    </Grid>
                    <Grid
                        item
                        sm={6}
                        xl={6}
                        xs={12}
                    >
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={props.chartOptionsStackedBar} />

                        <div style={{ float: "right", marginTop: "5%" }}>
                            <div style={{ float: "left" }}>
                                <UpdateIcon style={{ color: 'white' }} />
                            </div>
                            <Typography style={{ width: "350px", height: "1px", float: "right", marginTop: "5px", paddingLeft: "3px", color: 'white' }} color="textSecondary" gutterBottom>
                                {t('text.last-update')} {props.date}
                            </Typography>
                        </div>
                    </Grid>

                </Grid>
            </div>
        </div>

    )
}

function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
        var key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
    }, {});
}
SummaryObjectives.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired
};

export default compose(withStyles(styles), withTranslation())(SummaryObjectives);